import React from 'react'
import { Radio, Space } from 'antd'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'

type CourierTypes = 'partner' | 'other'

const CourierType = ({
  value,
  handleChange,
  disabled = false
}: {
  value: CourierTypes
  handleChange: (value: CourierTypes) => void
  disabled?: boolean
}) => {
  return (
    <Radio.Group
      defaultValue={value}
      onChange={(e) => handleChange(e.target.value)}
      disabled={disabled}
      value={value}
    >
      <Space direction='vertical' align='start'>
        <Radio value={'partner'} data-testid='courier-type-partner'>
          <span>Slerp courier partner</span>{' '}
          <Terms>
            View terms{' '}
            <TermsLink
              to='/settings/terms-and-conditions/dispatch'
              className='sidebar-tooltip'
            >
              here
            </TermsLink>
          </Terms>
        </Radio>
        <Radio value={'other'} data-testid='courier-type-other'>
          My own drivers
        </Radio>
      </Space>
    </Radio.Group>
  )
}

const Terms = styled.span`
  color: #d092dd;
  margin-left: 12px;
`

const TermsLink = styled(Link)`
  color: #d092dd;
  text-decoration: underline;

  &:hover {
    color: #d092dd;
  }
`

export default CourierType
